<template>
  <div>
    <a-form
      @submit="submit"
      :data="data"
      ref="form"
      :form="form"
    >
      <a-row class="form-row">
        <a-col>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="名称"
          >
            <a-input
              :read-only="params.isShow"
              placeholder="请输入名称"
              v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入名称' }]}]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            label="运费"
          >
            <a-input
              :read-only="params.isShow"
              placeholder="请输入运费"
              type="number"
              v-decorator="[
          'amount',
          {initialValue:data.amount,rules: [{ required: true, message: '请输入运费' }]}]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <div
        v-if="!this.params.isShow"
        class="hp-manager-dialog-footer"
      >
        <a-form-item label="">
          <a-button
            type="primary"
            @click="submit"
            :loading="loading"
          >确认</a-button>
          <a-button
            style="margin-left:10px"
            @click="cancel"
          >取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { fail } from "assert";
const defaultData = {
  id: 0,
  name: "",
  sortIndex: "",
  isActive: "启用",
  startTime: null,
  rangeTime: null,
  endTime: null,
  targetType: "0",
  targetId: null,
  targetName: "",
  targetUrl: ""
};
export default {
  name: "hp-manager-page-freight-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      targetTypeMessage: "",
      targetTypeLabel: "",
      listType: "text",
      selectProductVisible: false,
      selectAnnouncementVisible: false,
      selectActivityVisible: false,
      targetId: 0,
      fileList: []
    };
  },

  async mounted() {
    if (this.params.id) {
      this.data = this.params;
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf("day");
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },
    async submitHandler() {
      await api.AddOrUpdateFreight(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        amount: value.amount
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.AddOrUpdateFreight(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddOrUpdateFreight(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/Freight/Add.vue